module.exports = __webpack_public_path__ + "img/Kerchief.e9e9e8f3.png";